export default import.meta.ROLLDOWN_FILE_URL_KaEtoZ0JCR8K$z$RN1Ww6A